import {isTrue} from 'ramda-adjunct';

import {PatchDirectSaleVariantRequest} from '@dms/api/warehouse';

import {NullishBoolean} from 'shared/web';

import {WarehouseDirectSaleVariantsDetailFormSchemaType} from '../types/WarehouseDirectSaleVariantsDetailFormSchema';

type FormDocuments = WarehouseDirectSaleVariantsDetailFormSchemaType['documents'];
type PaymentDocumentsPatchBody = Pick<
  PatchDirectSaleVariantRequest['body']['documents'],
  'cashPayment' | 'cardPayment' | 'internalPayment'
>;

// Free of charge is always initiated automatically, so its checkbox is read-only in the form.
export const INTERNAL_AUTO_INITIATE_PAYMENT = true;

const isAutoInitiated = (payment: {isEnable: boolean; isAutoInitiatePayment?: NullishBoolean}) =>
  payment.isEnable && isTrue(payment.isAutoInitiatePayment);

// The cash register field is unmounted rather than unregistered when auto-initiation is switched
// off, so a hidden stale selection is cleared here instead of surviving into the request.
export function buildPaymentDocumentsPatchBody(
  documents: FormDocuments
): PaymentDocumentsPatchBody {
  const isCashAutoInitiated = isAutoInitiated(documents.cashPayment);

  return {
    cashPayment: {
      ...documents.cashPayment,
      isAutoInitiatePayment: isCashAutoInitiated,
      cashRegisterId: isCashAutoInitiated ? (documents.cashPayment.cashRegisterId ?? null) : null,
    },
    cardPayment: {
      ...documents.cardPayment,
      isAutoInitiatePayment: isAutoInitiated(documents.cardPayment),
    },
    internalPayment: {
      ...documents.internalPayment,
      isAutoInitiatePayment: INTERNAL_AUTO_INITIATE_PAYMENT,
      invoice: documents.internalPayment.isEnable ? documents.internalPayment.invoice : null,
      invoiceCorrection: documents.internalPayment.isEnable
        ? documents.internalPayment.invoiceCorrection
        : null,
    },
  };
}
